const questionnaireVariables = {
  USER_FIRST_NAME: 'user_firstName',
  USER_HAS_EMAIL_WITH_CONSENT: 'user_hasEmailWithConsent',
  USER_LAST_NAME: 'user_lastName',
  USER_SMS_CONSENT_GIVEN: 'user_smsConsentGiven',
  USER_WHATSAPP_CONSENT_GIVEN: 'user_whatsappConsentGiven',
};

export default questionnaireVariables;
